var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from './api';
import parseError from '@utils/helpers/parseError';
const authService = class AuthServcie {
    register({ email, password, name, }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield api.post('/auth/register', {
                    email,
                    password,
                    name,
                });
                return data;
            }
            catch (error) {
                const message = parseError(error);
                return { success: false, error: message };
            }
        });
    }
    verifyEmail({ email, verifyCode, }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield api.post('/auth/verify-email', {
                    email,
                    verifyCode,
                });
                return data;
            }
            catch (error) {
                const message = parseError(error);
                return { success: false, error: message };
            }
        });
    }
    reVerifyEmail(email) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield api.post('/auth/re-verify-email', { email });
                return data;
            }
            catch (error) {
                const message = parseError(error);
                return { success: false, error: message };
            }
        });
    }
    login({ email, password }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield api.post('/auth/login', {
                    email,
                    password,
                });
                return data;
            }
            catch (error) {
                const message = parseError(error);
                console.log('Parsed error:', message);
                return { success: false, error: message };
            }
        });
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield api.post('/auth/logout');
                return data;
            }
            catch (error) {
                const message = parseError(error);
                return { success: false, error: message };
            }
        });
    }
    updatePassword({ email, }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield api.post('/auth/update-password', { email });
                return data;
            }
            catch (error) {
                const message = parseError(error);
                return { success: false, error: message };
            }
        });
    }
    verifyPassword({ email, newPassword, repeatPassword, verifyCode, }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield api.post('/auth/verify-password', {
                    email,
                    newPassword,
                    repeatPassword,
                    verifyCode,
                });
                return data;
            }
            catch (error) {
                const message = parseError(error);
                return { success: false, error: message };
            }
        });
    }
};
const AuthService = new authService();
export default AuthService;
